import {
  completeDealActivity,
  deleteDealActivity,
  fetchDealActivities,
  insertDealActivity,
  insertQuickTask,
  reopenDealActivity,
  updateDealActivity,
} from '../../services/dealActivities';
import { notify } from '../../store/feedback';

export default function dealActivitiesHandlers(deps, api) {
  const {
    activityEdit,
    activityForm,
    dealModal,
    completeModal,
    quickTask,
    session,
    setActivityEdit,
    setActivityForm,
    setDealActivityList,
    setCompleteModal,
    setQuickTask,
  } = deps;

  async function loadDealActivities(dealId) {
    const { data } = await fetchDealActivities(dealId);
    const sorted = (data || []).sort(
      (a, b) =>
        (b.date || '').localeCompare(a.date || '') ||
        (b.created_at || '').localeCompare(a.created_at || ''),
    );
    setDealActivityList(sorted);
  }

  async function addActivity() {
    if (!dealModal?.id) return;
    const f = activityForm;
    await insertDealActivity(dealModal, f, session);
    setActivityForm({ type: 'Appel', date: '', etat: 'prevu', note: '' });
    await loadDealActivities(dealModal.id);
    api.loadDeals();
  }

  async function saveQuickTask() {
    const t = quickTask;
    if (!t.affaire_id) {
      notify('Choisis une affaire.');
      return;
    }
    await insertQuickTask(session, t);
    setQuickTask(null);
    api.loadDeals();
  }

  function toggleActivityDone(act) {
    if (act.etat === 'fait') {
      // Annuler la validation directement
      reopenDealActivity(act, loadDealActivities, api.loadDeals);
    } else {
      // Ouvrir la modal de complétion
      setCompleteModal({ act, noteCompletion: '' });
    }
  }

  async function confirmComplete() {
    const { act, noteCompletion } = completeModal;
    await completeDealActivity(act, noteCompletion, session);
    setCompleteModal(null);
    if (act.affaire_id) await loadDealActivities(act.affaire_id);
    api.loadDeals();
  }

  async function deleteActivity(act) {
    await deleteDealActivity(act);
    await loadDealActivities(act.affaire_id);
    api.loadDeals();
  }

  async function saveActivityEdit() {
    const e = activityEdit;
    if (!e) return;
    await updateDealActivity(e);
    setActivityEdit(null);
    if (dealModal?.id) await loadDealActivities(dealModal.id);
    api.loadDeals();
  }

  return {
    loadDealActivities,
    addActivity,
    saveQuickTask,
    toggleActivityDone,
    confirmComplete,
    deleteActivity,
    saveActivityEdit,
  };
}
